<template>
    <div>
        <div class="modal fade modern-modal" ref="modalImportacaoItem" id="ModalImportacaoItem" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered modal-modern modal-grande">
                <div class="modal-content modal-modern-content border-0">
                    <button type="button" class="btn btn-md btn-icon btn-pill btn-white shadow position-absolute top-0 end-0 mt-n3 me-n3"
                            data-bs-dismiss="modal">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                        </svg>
                    </button>

                    <div class="modal-modern-header">
                        <div class="header-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M4 3H18C19.11 3 20 3.9 20 5V12.08C18.45 11.82 16.92 12.18 15.68 13H12V17H13.08C12.97 17.68 12.97 18.35 13.08 19H4C2.9 19 2 18.11 2 17V5C2 3.9 2.9 3 4 3M4 7V11H10V7H4M12 7V11H18V7H12M4 13V17H10V13H4M18.44 15V17H22.44V19H18.44V21L15.44 18L18.44 15" />
                            </svg>
                            
                        </div>
                        <div class="header-text">
                            <h2>Importação de Itens</h2>
                            <p>Faça o upload da planilha, mapeie os campos obrigatórios e finalize a importação em duas etapas guiadas.</p>
                        </div>
                        <div class="header-steps">
                            <div class="step-progress">
                                <div class="step-progress-item" :class="{ active: step >= 1, completed: step > 1 }">
                                    <span>1</span>
                                    <small>Preparar</small>
                                </div>
                                <div class="step-progress-connector" :class="{ completed: step > 1 }"></div>
                                <div class="step-progress-item" :class="{ active: step === 2, completed: step === 2 && isMappingValid }">
                                    <span>2</span>
                                    <small>Mapear</small>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="modal-modern-body">
                        <transition name="fade-step" mode="out-in">
                            <div v-if="step === 1" key="step-1" class="wizard-step">
                                <div class="wizard-grid">
                                    <div class="wizard-col">
                                        <div class="section-card info-card">
                                            <div class="section-card-header">
                                                <span class="section-badge">Passo 1</span>
                                                <h3>Prepare sua planilha</h3>
                                                <p>Siga as orientações para evitar inconsistências durante o processo.</p>
                                            </div>
                                            <div class="section-card-body">
                                                <div class="mandatory-chips">
                                                    <span class="mandatory-label">Campos obrigatórios</span>
                                                    <div class="mandatory-tags">
                                                        <span class="chip-obrigatorio">Nome</span>
                                                        <span class="chip-obrigatorio">Código</span>
                                                        <span class="chip-obrigatorio">Tipo de Item</span>
                                                        <span class="chip-obrigatorio">Unidade de Medida</span>
                                                        <span class="chip-obrigatorio">Quantidade</span>
                                                        <span class="chip-obrigatorio">Valor Unitário</span>
                                                        <span class="chip-obrigatorio">Lote</span>
                                                        <span class="chip-opcional">Periodicidade</span>
                                                    </div>
                                                    <small class="text-muted d-block mt-2">Periodicidade é obrigatória apenas para linhas cuja unidade de medida exige intervalo de tempo (ex.: mês, dia, hora).</small>
                                                </div>
                                                <div class="info-blocks">
                                                    <div class="info-block">
                                                        <div class="info-block-title">Primeira linha</div>
                                                        <div class="info-block-desc">Use a primeira linha para os nomes das colunas da planilha.</div>
                                                    </div>
                                                    <div class="info-block">
                                                        <div class="info-block-title">Ordem dos campos</div>
                                                        <div class="info-block-desc">Os campos podem estar em qualquer ordem. Organizaremos na etapa seguinte.</div>
                                                    </div>
                                                    <div class="info-block">
                                                        <div class="info-block-title">Mapeamento guiado</div>
                                                        <div class="info-block-desc">Você fará o arraste-e-solte das colunas na próxima etapa.</div>
                                                    </div>
                                                    <button type="button" class="info-block info-block-clickable" @click="abrirModalRegrasTipo">
                                                        <div class="info-block-title">Regras adicionais</div>
                                                        <div class="info-block-desc">Confira todas as regras para garantir uma importação sem erros.</div>
                                                    </button>
                                                    <button type="button" class="info-block info-block-clickable" @click="downloadModelo">
                                                        <div class="info-block-title">Baixar modelo</div>
                                                        <div class="info-block-desc">Faça o download da planilha modelo e preencha com seus itens.</div>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="wizard-col">
                                        <div class="section-card upload-card">
                                            <div class="section-card-header">
                                                <span class="section-badge section-badge-secondary">Upload</span>
                                                <h3>Envie sua planilha</h3>
                                                <p>Arraste um arquivo .xlsx ou .csv ou clique para escolher no seu dispositivo.</p>
                                            </div>
                                            <div class="section-card-body">
                                                <div v-if="file" class="file-thumbnail">
                                                    <div class="file-icon">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                            <path d="M14 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V8L14 2Z" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                                                            <path d="M14 2V8H20" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                                                        </svg>
                                                    </div>
                                                    <div class="file-info">
                                                        <strong>{{ file.name }}</strong>
                                                        <span>{{ file.type || 'Tipo desconhecido' }}</span>
                                                    </div>
                                                    <button type="button" class="file-remove-btn" @click="removeFile" title="Remover arquivo">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                                                            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                                                        </svg>
                                                    </button>
                                                </div>
                                                <div v-else class="upload-wrapper">
                                                    <div class="upload-dropzone"
                                                         @dragover.prevent
                                                         @drop.prevent="handleDrop">
                                                        <input type="file"
                                                               id="inputImportacaoItem"
                                                               class="d-none"
                                                               @change="handleFileChange"
                                                               accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" />
                                                        <label for="inputImportacaoItem" class="upload-label">
                                                            <span class="upload-icon">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 24 24" fill="none">
                                                                    <path d="M12 16V2M12 2L8 6M12 2L16 6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                                                                    <path d="M20 10V20C20 21.1046 19.1046 22 18 22H6C4.89543 22 4 21.1046 4 20V10" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                                                                </svg>
                                                            </span>
                                                            <span class="upload-text">Arraste o arquivo aqui ou clique para escolher</span>
                                                            <span class="upload-subtext">Formatos aceitos: .xlsx, .xls e .csv</span>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-else-if="step === 2" key="step-2" class="wizard-step">
                                <div class="section-card mapping-card">
                                    <div class="section-card-header">
                                        <span class="section-badge">Passo 2</span>
                                        <h3>Mapeie os campos do sistema</h3>
                                        <p>Arraste as colunas disponíveis para cada campo obrigatório do sistema.</p>
                                        <p v-if="planilhaPossuiUnidadeComPeriodicidade" class="mapping-hint-required mt-2 mb-0">
                                            A planilha possui unidade com periodicidade. O campo <strong>Periodicidade</strong> é obrigatório.
                                        </p>
                                    </div>
                                    <div class="section-card-body">
                                        <div class="gamify-mapping-container row justify-content-center">
                                            <div class="col-md-7">
                                                <div class="mapping-grid">
                                                    <div v-for="field in systemFields" :key="field.key" class="mapping-card gamify-card position-relative"
                                                         :class="{'required': field.required, 'drop-hover': field.dropHover, 'mapped': field.mappedColumn, 'missing': field.required && !field.mappedColumn && triedConfirm}"
                                                         @dragover.prevent="onDragOverField(field)"
                                                         @dragleave.prevent="onDragLeaveField(field)"
                                                         @drop.prevent="onDropField(field)"
                                                         :title="field.tip">
                                                        <div class="d-flex align-items-center gap-2 mb-1">
                                                            <i :class="field.icon" class="field-icon"></i>
                                                            <span class="fw-bold">{{ field.label }}</span>
                                                            <span v-if="field.required && !field.mappedColumn" class="badge badge-estado badge-required">Obrigatório</span>
                                                            <span v-if="field.required && field.mappedColumn" class="badge badge-estado badge-ok">OK</span>
                                                            <span v-if="!field.required && !field.mappedColumn" class="badge badge-estado badge-optional">Opcional</span>
                                                            <span v-if="!field.required && field.mappedColumn" class="badge badge-estado badge-ok">OK</span>
                                                        </div>
                                                        <div class="drop-area text-center" :class="{'has-chip': field.mappedColumn}">
                                                            <template v-if="field.mappedColumn">
                                                                <span class="chip mapped-chip animate__animated animate__fadeIn mapped-chip-ellipsis" :title="field.mappedColumn">
                                                                    <span class="chip-text-ellipsis">{{ field.mappedColumn }}</span>
                                                                    <i class="fas fa-times ms-2 chip-remove" @click.stop="removeMapping(field)"></i>
                                                                </span>
                                                            </template>
                                                            <template v-else>
                                                                <span class="text-muted">Arraste aqui</span>
                                                            </template>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-3 d-flex flex-column align-items-center">
                                                <div class="available-header">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none">
                                                        <path d="M12 8V12L14.5 14.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                                                    </svg>
                                                    <span>Colunas disponíveis</span>
                                                </div>
                                                <div class="available-columns">
                                                    <span v-for="col in availableColumns" :key="col.name" class="drag-block animate__animated animate__pulse" draggable="true"
                                                          @dragstart="onDragStart(col)" @dragend="onDragEnd" :title="col.name">
                                                        <i class="fas fa-grip-lines-vertical drag-icon me-2"></i>
                                                        <span class="drag-block-text">{{ col.name }}</span>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="step-warning" v-if="precisaMapearPeriodicidade && triedConfirm">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none">
                                                <path d="M12 8V12" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M12 16H12.01" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                            <span>Há itens com unidade que exige periodicidade. Mapeie a coluna Periodicidade.</span>
                                        </div>
                                        <div class="step-warning" v-if="!isMappingValid && triedConfirm">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none">
                                                <path d="M12 8V12" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M12 16H12.01" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                            <span>Mapeie todos os campos obrigatórios para continuar.</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </transition>
                    </div>

                    <div class="modal-modern-footer">
                        <template v-if="step === 1">
                            <button type="button" class="modern-btn modern-btn-secondary" @click="fecharModal">Cancelar</button>
                            <button type="button" class="modern-btn modern-btn-primary" @click="goToMappingStep">Próximo</button>
                        </template>
                        <template v-else-if="step === 2">
                            <button type="button" class="modern-btn modern-btn-light" @click="voltarMapping">Voltar</button>
                            <button type="button"
                                    class="modern-btn modern-btn-primary"
                                    :disabled="!isMappingValid || isImporting"
                                    @click="confirmMapping">
                                <span v-if="!isImporting">Confirmar e importar</span>
                                <span v-else class="d-inline-flex align-items-center gap-2">
                                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    Processando...
                                </span>
                            </button>
                        </template>
                    </div>
                </div>
            </div>
            <!-- Modal de Regras da Coluna Tipo -->
        </div>
        <div class="modal fade modern-modal" ref="modalRegrasTipo" id="ModalRegrasTipo" tabindex="-1">
            <div class="modal-dialog modal-modern modal-regras">
                <div class="modal-content modal-modern-content border-0">
                    <button type="button" class="btn btn-md btn-icon btn-pill btn-white shadow position-absolute top-0 end-0 mt-n3 me-n3"
                            data-bs-dismiss="modal">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                        </svg>
                    </button>

                    <div class="modal-modern-header">
                        <div class="header-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none">
                                <path d="M12 9V12" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M12 16H12.01" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                        <div class="header-text">
                            <h2>Regras de Importação</h2>
                            <p>Revise estas diretrizes para evitar falhas na validação e garantir um carregamento consistente dos dados.</p>
                        </div>
                    </div>

                    <div class="modal-modern-body modal-body-regras">
                        <div class="rules-grid">
                            <div class="rule-card">
                                <div class="rule-header">
                                    <div class="rule-icon rule-icon-blue">
                                        <i class="bi bi-tag"></i>
                                    </div>
                                    <div>
                                        <h4>Tipo de Item</h4>
                                        <p>Identifique corretamente se cada linha representa um material ou um serviço.</p>
                                    </div>
                                </div>
                                <ul class="rule-list">
                                    <li>Use <strong>M</strong> ou <strong>Material</strong> para materiais.</li>
                                    <li>Use <strong>S</strong> ou <strong>Serviço</strong> para serviços.</li>
                                    <li class="rule-alert">Evite variações como “material de ...”, “servicos”, “SVC”, entre outras abreviações.</li>
                                </ul>
                            </div>

                            <div class="rule-card">
                                <div class="rule-header">
                                    <div class="rule-icon rule-icon-teal">
                                        <i class="bi bi-rulers"></i>
                                    </div>
                                    <div>
                                        <h4>Unidade de Medida</h4>
                                        <p>Utilize somente unidades previamente cadastradas para manter o padrão da base.</p>
                                    </div>
                                </div>
                                <ul class="rule-list">
                                    <li>Informe unidades já existentes no sistema.</li>
                                    <li>Para novas unidades, cadastre-as primeiro na tela de itens.</li>
                                    <li>Aceitamos tanto o nome quanto a abreviação (ex.: “Metro” ou “m”).</li>
                                </ul>
                            </div>

                            <div class="rule-card">
                                <div class="rule-header">
                                    <div class="rule-icon rule-icon-purple">
                                        <i class="bi bi-upc-scan"></i>
                                    </div>
                                    <div>
                                        <h4>Código e Valor</h4>
                                        <p>Garanta a unicidade dos códigos por lote e informe valores em formato numérico.</p>
                                    </div>
                                </div>
                                <ul class="rule-list">
                                    <li>Não repita o mesmo código dentro de um lote.</li>
                                    <li>Informe apenas números no valor unitário, por exemplo <code>15,50</code>.</li>
                                    <li>Não inclua “R$” antes ou depois do valor.</li>
                                </ul>
                            </div>

                            <div class="rule-card">
                                <div class="rule-header">
                                    <div class="rule-icon rule-icon-amber">
                                        <i class="bi bi-layers"></i>
                                    </div>
                                    <div>
                                        <h4>Lotes</h4>
                                        <p>Organize os itens por lote numérico, seguindo a configuração do processo.</p>
                                    </div>
                                </div>
                                <ul class="rule-list">
                                    <li>Utilize somente números inteiros iniciando em 1.</li>
                                    <li>Em processos com lote único, mantenha todos os itens com o valor <strong>1</strong>.</li>
                                </ul>
                            </div>

                            <div class="rule-card">
                                <div class="rule-header">
                                    <div class="rule-icon rule-icon-blue">
                                        <i class="bi bi-clock-history"></i>
                                    </div>
                                    <div>
                                        <h4>Periodicidade</h4>
                                        <p>Obrigatória somente quando a unidade de medida exige intervalo de tempo.</p>
                                    </div>
                                </div>
                                <ul class="rule-list">
                                    <li>Mapeie a coluna quando houver itens com unidade de periodicidade.</li>
                                    <li>Informe periodicidades cadastradas no sistema (nome ou código, ex.: Mês, Dia, Hora).</li>
                                    <li class="rule-alert">Linhas com unidade que exige periodicidade devem ter a coluna preenchida.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import Swal from 'sweetalert2'
    import * as XLSX from 'xlsx';
    import { urlApi, avisoErro, avisoToast } from '@/config/global';

    export default {
        name: 'ModalImportarFuncionarios',
        props: {
            idProcesso: String,
            isLoteUnico: Boolean
        },
        data() {
            return {
                step: 1,
                file: null,
                sheetColumns: [],
                previewRow: null,
                systemFields: [
                    { key: 'nome', label: 'Nome', mappedColumn: null, required: true, icon: '', dropHover: false, tip: 'Qualquer Texto.' },
                    { key: 'codigo', label: 'Código', mappedColumn: null, required: true, icon: '', dropHover: false, tip: 'Apenas Valores Númericos' },
                    { key: 'tipoItem', label: 'Tipo de Item', mappedColumn: null, required: true, icon: '', dropHover: false, tip: '"M", "S", Material ou Serviço.' },
                    { key: 'unidadeMedida', label: 'Unidade de Medida', mappedColumn: null, required: true, icon: '', dropHover: false, tip: 'Unidade de Medida Existente' },
                    { key: 'periodicidade', label: 'Periodicidade', mappedColumn: null, required: false, icon: '', dropHover: false, tip: 'Obrigatória quando a unidade exige periodicidade (ex.: Mês, Dia, Hora).' },
                    { key: 'quantidade', label: 'Quantidade', mappedColumn: null, required: true, icon: '', dropHover: false, tip: 'Qualquer Valor.' },
                    { key: 'valorUnitario', label: 'Valor Unitário', mappedColumn: null, required: true, icon: '', dropHover: false, tip: 'Qualquer Valor, inclusive 0.' },
                    { key: 'valorSigiloso', label: 'Valor sigiloso', mappedColumn: null, required: false, icon: '', dropHover: false, tip: 'Opcional. Sim, S, 1 ou true. Não, N, 0 ou false. Vazio mantém desligado.' },
                    { key: 'lote', label: 'Lote', mappedColumn: null, required: true, icon: '', dropHover: false, tip: 'Apenas o Número do Lote.' }
                ],
                draggingColumn: null,
                triedConfirm: false,
                unidadesMedida: [],
                periodicidades: [],
                retornoAoFechar: null,
                foiFechadaDeFormaTemporaria: false,
                codigoLoteExistentes: new Set(),
                isImporting: false,
            };
        },
        computed: {
            availableColumns() {
                // Colunas ainda não mapeadas
                const mapped = this.systemFields.map(f => f.mappedColumn).filter(Boolean);
                return this.sheetColumns.filter(col => !mapped.includes(col.name));
            },
            isMappingValid() {
                return this.systemFields.filter(f => f.required).every(f => f.mappedColumn);
            },
            planilhaPossuiUnidadeComPeriodicidade() {
                if (!this.allRows?.length || !this.unidadesMedida?.length) return false;

                const unidadeCol = this.systemFields.find(f => f.key === 'unidadeMedida')?.mappedColumn;

                if (unidadeCol) {
                    const unidadeIdx = this.sheetColumns.findIndex(c => c.name === unidadeCol);
                    if (unidadeIdx < 0) return false;

                    return this.allRows.some(row => {
                        const valor = row[unidadeIdx] != null ? String(row[unidadeIdx]).trim() : '';
                        return !!this.obterUnidadeMedida(valor)?.flPeriodicidade;
                    });
                }

                return this.allRows.some(row =>
                    row.some(cell => {
                        if (cell == null || cell === '') return false;
                        return !!this.obterUnidadeMedida(cell)?.flPeriodicidade;
                    })
                );
            },
            precisaMapearPeriodicidade() {
                const campoPeriodicidade = this.systemFields.find(f => f.key === 'periodicidade');
                return this.planilhaPossuiUnidadeComPeriodicidade && !campoPeriodicidade?.mappedColumn;
            }
        },
        methods: {
            ajustarObrigatoriedadeLote() {
                const campoLote = this.systemFields.find(f => f.key === 'lote');
                if (campoLote) {
                    campoLote.required = !this.isLoteUnico;
                    campoLote.tip = this.isLoteUnico
                        ? 'Todos os itens ficarão no mesmo lote. Esse campo é opcional.'
                        : 'Apenas o Número do Lote.';
                }
            },

            ajustarObrigatoriedadePeriodicidade() {
                const campoPeriodicidade = this.systemFields.find(f => f.key === 'periodicidade');
                if (!campoPeriodicidade) return;

                const exige = this.planilhaPossuiUnidadeComPeriodicidade;
                campoPeriodicidade.required = exige;
                campoPeriodicidade.tip = exige
                    ? 'Obrigatório: a planilha possui itens com unidade que exige periodicidade (ex.: Mês, Dia, Ano).'
                    : 'Opcional. Obrigatório apenas quando a unidade exige periodicidade.';
            },

            handleFileChange(event) {
                this.file = event.target.files[0];
            },

            handleDrop(event) {
                const files = event.dataTransfer.files;
                if (files.length) {
                    this.file = files[0];
                }
            },

            getUnidadesMedida() {
                return axios.get(`${urlApi}/CadastroItem/GetUnidadesMedida`)
                    .then(res => {
                        if (res.data) {
                            this.unidadesMedida = res.data.data;
                        } else {
                            avisoErro("Não foi possível carregar as unidades de medida.");
                        }
                    })
                    .catch(() => {
                        avisoErro("Erro ao buscar unidades de medida.");
                    });
            },

            getPeriodicidades() {
                return axios.get(`${urlApi}/CadastroItem/GetPeriodicidades`)
                    .then(res => {
                        if (res.data) {
                            this.periodicidades = res.data.data || [];
                        } else {
                            avisoErro("Não foi possível carregar as periodicidades.");
                        }
                    })
                    .catch(() => {
                        avisoErro("Erro ao buscar periodicidades.");
                    });
            },

            obterUnidadeMedida(valor) {
                if (!valor) return null;
                const normalizado = String(valor).trim().toLowerCase();
                return this.unidadesMedida.find(unidade => {
                    const nome = String(unidade.nmUnidadeMedida || '').trim().toLowerCase();
                    const codigo = String(unidade.cdUnidadeMedida || '').trim().toLowerCase();
                    return normalizado === nome || normalizado === codigo;
                }) || null;
            },

            validarUnidadeMedida(valor) {
                return !!this.obterUnidadeMedida(valor);
            },

            validarPeriodicidade(valor) {
                if (!valor) return false;
                const normalizado = String(valor).trim().toLowerCase();
                return this.periodicidades.some(p => {
                    const nome = String(p.nmPeriodicidade || '').trim().toLowerCase();
                    const codigo = String(p.cdPeriodicidade || '').trim().toLowerCase();
                    return normalizado === nome || normalizado === codigo;
                });
            },

            validarRequisitoPeriodicidadeNasLinhas() {
                const erros = [];
                const unidadeCol = this.systemFields.find(f => f.key === 'unidadeMedida')?.mappedColumn;
                const periodicidadeCol = this.systemFields.find(f => f.key === 'periodicidade')?.mappedColumn;

                if (!unidadeCol || !this.allRows?.length) return erros;

                const unidadeIdx = this.sheetColumns.findIndex(c => c.name === unidadeCol);
                const periodicidadeIdx = periodicidadeCol
                    ? this.sheetColumns.findIndex(c => c.name === periodicidadeCol)
                    : -1;

                let exigeMapeamentoPeriodicidade = false;

                this.allRows.forEach((row, idx) => {
                    const linha = idx + 2;
                    const unidadeValue = row[unidadeIdx] != null ? String(row[unidadeIdx]).trim() : '';
                    const unidade = this.obterUnidadeMedida(unidadeValue);

                    if (!unidade?.flPeriodicidade) return;

                    exigeMapeamentoPeriodicidade = true;

                    if (periodicidadeIdx < 0) return;

                    const periodicidadeValue = row[periodicidadeIdx] != null ? String(row[periodicidadeIdx]).trim() : '';
                    if (!periodicidadeValue) {
                        erros.push(`Linha ${linha}: Periodicidade obrigatória para a unidade "${unidadeValue}".`);
                        return;
                    }

                    if (!this.validarPeriodicidade(periodicidadeValue)) {
                        erros.push(`Linha ${linha}: Periodicidade inválida (${periodicidadeValue}).`);
                    }
                });

                if (exigeMapeamentoPeriodicidade && periodicidadeIdx < 0) {
                    erros.unshift('Mapeie a coluna Periodicidade: há itens com unidade que exige periodicidade.');
                }

                return erros;
            },

            goToMappingStep() {
                this.ajustarObrigatoriedadeLote();
                if (!this.file) {
                    avisoErro('Selecione um arquivo para importar.');
                    return;
                }
                this.getUnidadesMedida().then(() => {
                    this.ajustarObrigatoriedadePeriodicidade();
                });
                this.getPeriodicidades();
                this.getItensDetalhados();

                const reader = new FileReader();
                reader.onload = (e) => {
                    let columns = [];
                    let previewRow = [];

                    if (this.file.name.endsWith('.csv')) {
                        const lines = e.target.result.split('\n');
                        columns = lines[0].replace(/\r/g, '').split(',');
                        previewRow = lines[1] ? lines[1].replace(/\r/g, '').split(',') : [];
                    } else {
                        const data = new Uint8Array(e.target.result);
                        const workbook = XLSX.read(data, { type: 'array' });
                        const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
                        const rows = XLSX.utils.sheet_to_json(firstSheet, { header: 1 });
                        this.sheetColumns = rows[0].filter(Boolean).map(name => ({ name }));
                        this.allRows = rows.slice(1).filter(row => row.some(cell => cell !== null && cell !== undefined && cell !== ''));
                        columns = rows[0];
                        previewRow = rows[1] || [];
                    }

                    this.sheetColumns = columns.filter(Boolean).map(name => ({ name }));
                    this.previewRow = previewRow;

                    const obrigatorios = this.systemFields.filter(f => f.required).length;
                    if (this.sheetColumns.length < obrigatorios) {
                        avisoErro(`A planilha possui apenas ${this.sheetColumns.length} colunas. São necessários ao menos ${obrigatorios} campos obrigatórios.`);
                        return;
                    }

                    this.systemFields.forEach(f => { f.mappedColumn = null; });
                    this.triedConfirm = false;
                    this.ajustarObrigatoriedadePeriodicidade();
                    this.step = 2;
                };

                if (this.file.name.endsWith('.csv')) {
                    reader.readAsText(this.file);
                } else {
                    reader.readAsArrayBuffer(this.file);
                }
            },

            onDragStart(col) {
                this.draggingColumn = col.name;
            },

            onDragEnd() {
                this.draggingColumn = null;
                this.systemFields.forEach(f => (f.dropHover = false));
            },

            onDragOverField(field) {
                if (this.draggingColumn && !field.mappedColumn) {
                    field.dropHover = true;
                }
            },

            onDragLeaveField(field) {
                field.dropHover = false;
            },

            onDropField(field) {
                if (!this.draggingColumn || field.mappedColumn) return;

                const colIdx = this.sheetColumns.findIndex(col => col.name === this.draggingColumn);
                if (colIdx === -1) return;

                const erros = [];

                if (!this.codigoLoteUnicos) this.codigoLoteUnicos = new Map();

                this.allRows.forEach((row, idx) => {
                    const linha = idx + 2; // começa na linha 2 da planilha (após header)
                    const raw = row[colIdx];
                    const value = raw !== null && raw !== undefined ? String(raw).trim() : '';
                    let valido = true;

                    switch (field.key) {
                        case 'nome':
                            valido = !!value;
                            if (!valido) erros.push(`Linha ${linha}: Nome vazio`);
                            break;

                        case 'codigo': {
                            valido = !!value;
                            if (!valido) {
                                erros.push(`Linha ${linha}: Código inválido (${value})`);
                                break;
                            }

                            const loteCol = this.systemFields.find(f => f.key === 'lote')?.mappedColumn;
                            if (loteCol) {
                                const loteIdx = this.sheetColumns.findIndex(c => c.name === loteCol);
                                const loteValue = row[loteIdx] ? String(row[loteIdx]).trim() : '';
                                const chaveDuplicada = `${value.toLowerCase()}_${loteValue}`;

                                if (this.codigoLoteUnicos.has(chaveDuplicada)) {
                                    erros.push(`Linha ${linha}: Código '${value}' já existe no lote ${loteValue}.`);
                                } else {
                                    this.codigoLoteUnicos.set(chaveDuplicada, true);
                                }
                            }
                            break;
                        }

                        case 'tipoItem':
                            valido = ['m', 'material', 's', 'serviço'].includes(value.toLowerCase());
                            if (!valido) erros.push(`Linha ${linha}: Tipo inválido (${value}). O tipo deve ser M, Material, S ou Serviço.`);
                            break;

                        case 'unidadeMedida':
                            valido = this.validarUnidadeMedida(value);
                            if (!valido) erros.push(`Linha ${linha}: Unidade inválida (${value})`);
                            break;

                        case 'periodicidade':
                            if (value && !this.validarPeriodicidade(value)) {
                                valido = false;
                                erros.push(`Linha ${linha}: Periodicidade inválida (${value})`);
                            }
                            break;

                        case 'quantidade':
                        case 'valorUnitario':
                            valido = value !== '' && !isNaN(parseFloat(value)) && isFinite(value);
                            if (!valido) erros.push(`Linha ${linha}: ${field.label} inválido (${value})`);
                            break;

                        case 'valorSigiloso': {
                            if (!value) break;
                            const texto = value.toLowerCase();
                            valido = ['sim', 's', '1', 'true', 'não', 'nao', 'n', '0', 'false'].includes(texto);
                            if (!valido) erros.push(`Linha ${linha}: Valor sigiloso inválido (${value}). Use Sim, Não, S, N, 1, 0, true ou false.`);
                            break;
                        }

                        case 'lote': {
                            valido = /^\d+$/.test(value);
                            if (!valido) {
                                erros.push(`Linha ${linha}: Lote inválido (${value})`);
                                break;
                            }

                            const codigoCol = this.systemFields.find(f => f.key === 'codigo')?.mappedColumn;
                            if (codigoCol) {
                                const codigoIdx = this.sheetColumns.findIndex(c => c.name === codigoCol);
                                const codigoValue = row[codigoIdx] ? String(row[codigoIdx]).trim() : '';
                                const chaveDuplicada = `${codigoValue.toLowerCase()}_${value}`;

                                if (this.codigoLoteUnicos.has(chaveDuplicada)) {
                                    erros.push(`Linha ${linha}: A combinação Código '${codigoValue}' e Lote '${value}' já existe.`);
                                } else {
                                    this.codigoLoteUnicos.set(chaveDuplicada, true);
                                }
                            }
                            break;
                        }
                    }
                });

                if (field.key === 'periodicidade') {
                    const previousMapping = field.mappedColumn;
                    field.mappedColumn = this.draggingColumn;
                    erros.push(...this.validarRequisitoPeriodicidadeNasLinhas());
                    field.mappedColumn = previousMapping;
                }

                if (erros.length > 0) {
                    avisoErro(`Erro(s) encontrados:\n- ${erros.slice(0, 10).join('\n')}${erros.length > 10 ? `\n...e mais ${erros.length - 10} erro(s).` : ''}`);
                    field.dropHover = false;
                    this.draggingColumn = null;
                    return;
                }

                field.mappedColumn = this.draggingColumn;
                field.dropHover = false;
                this.draggingColumn = null;
                this.ajustarObrigatoriedadePeriodicidade();
            },

            removeMapping(field) {
                field.mappedColumn = null;
                this.ajustarObrigatoriedadePeriodicidade();
            },

            resetMapping() {

                this.sheetColumns = [];
                this.previewRow = null;
                this.systemFields.forEach(f => {
                    f.mappedColumn = null;
                });
                this.ajustarObrigatoriedadePeriodicidade();
                this.codigoLoteUnicos = new Map();
                this.triedConfirm = false;
            },

            async confirmMapping() {
                this.triedConfirm = true;

                if (!this.isMappingValid) {
                    avisoErro("Mapeie todos os campos obrigatórios.");
                    return;
                }

                const errosPeriodicidade = this.validarRequisitoPeriodicidadeNasLinhas();
                if (errosPeriodicidade.length > 0) {
                    avisoErro(`Erro(s) encontrados:\n- ${errosPeriodicidade.slice(0, 10).join('\n')}${errosPeriodicidade.length > 10 ? `\n...e mais ${errosPeriodicidade.length - 10} erro(s).` : ''}`);
                    return;
                }

                const result = await Swal.fire({
                    title: 'Importar nova planilha?',
                    html: `<div class="text-start">
                                <p class="mb-2">Ao continuar, <b>todos os itens já cadastrados neste processo serão excluídos</b>.</p>
                                    <ul class="mb-0">
                                    <li>A exclusão será feita primeiro.</li>
                                    <li>Em seguida a nova importação será iniciada.</li>
                                    </ul>
                           </div>`,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#d33',
                    cancelButtonColor: '#2563EB',
                    confirmButtonText: 'Sim, excluir e importar',
                    cancelButtonText: 'Cancelar'
                });

                if (!result.isConfirmed) return;

                const mapping = {};
                this.systemFields.forEach(f => {
                    if (f.mappedColumn) mapping[f.key] = f.mappedColumn;
                });

                const formData = new FormData();
                formData.append('file', this.file);
                formData.append('mapping', JSON.stringify(mapping));
                formData.append('idProcesso', this.idProcesso);

                try {
                    this.isImporting = true;

                    avisoToast('Limpando itens do processo...');
                    await this.limparProcessoTotal();
                    this.codigoLoteExistentes = new Set();
                    await this.getItensDetalhados();

                    avisoToast('Processo limpo. Iniciando importação...');
                    await axios.post(`${urlApi}/CadastroItem/PostImportacao`, formData, {
                        headers: { 'Content-Type': 'multipart/form-data' }
                    });

                    avisoToast('Importação iniciada com sucesso. Você receberá um e-mail quando for concluída.');

                    this.file = null;
                    this.sheetColumns = [];
                    this.previewRow = null;
                    this.systemFields.forEach(f => { f.mappedColumn = null; });
                    this.step = 1;

                    this.fecharModal();
                } catch (error) {
                    console.error(error);
                    avisoErro(error?.message || 'Erro no processo de importação.');
                } finally {
                    this.isImporting = false;
                }
            },

            voltarMapping() {
                this.step = 1;
                this.resetMapping();
            },

            abrirModal(callbackDeRetorno) {
                this.ajustarObrigatoriedadeLote();
                this.retornoAoFechar = callbackDeRetorno;
                this.resetMapping();
                this.step = 1;
                this.file = null;
                const modalEl = this.$refs.modalImportacaoItem;
                const modalInstance = new window.bootstrap.Modal(modalEl);
                modalInstance.show();

                const onHidden = () => {
                    if (this.foiFechadaDeFormaTemporaria) {
                        this.foiFechadaDeFormaTemporaria = false;
                        return;
                    }

                    if (typeof this.retornoAoFechar === 'function') {
                        this.retornoAoFechar();
                        this.retornoAoFechar = null;
                    }

                    modalEl.removeEventListener('hidden.bs.modal', onHidden);
                };


                modalEl.addEventListener('hidden.bs.modal', onHidden);
            },

            fecharModal() {
                const modal = window.bootstrap.Modal.getInstance(this.$refs.modalImportacaoItem);
                if (modal) modal.hide();
                this.resetMapping();
                if (typeof this.retornoAoFechar === 'function') {
                    this.retornoAoFechar();
                    this.retornoAoFechar = null;
                }
            },

            removeFile() {
                this.file = null;
                this.sheetColumns = [];
                this.previewRow = null;
            },

            abrirModalRegrasTipo() {
                this.foiFechadaDeFormaTemporaria = true;

                const modalImport = window.bootstrap.Modal.getInstance(this.$refs.modalImportacaoItem);
                if (modalImport) modalImport.hide();

                const modalRegras = new window.bootstrap.Modal(this.$refs.modalRegrasTipo);
                modalRegras.show();

                const onHidden = () => {
                    this.$refs.modalRegrasTipo.removeEventListener('hidden.bs.modal', onHidden);

                    const modalImportExistente = window.bootstrap.Modal.getInstance(this.$refs.modalImportacaoItem);
                    if (modalImportExistente) {
                        modalImportExistente.show();
                    }
                };

                this.$refs.modalRegrasTipo.addEventListener('hidden.bs.modal', onHidden, { once: true });
            },

            getItensDetalhados() {
                let $this = this;
                return axios.get(`${urlApi}/ProcessoItem/GetItensDetalhados`, {
                    params: { idProcesso: this.idProcesso }
                })
                    .then(res => {
                        if (res.data && res.data.data && res.data.data.rows) {
                            const rows = res.data.data.rows;
                            $this.codigoLoteExistentes = new Set(
                                rows.map(item => `${String(item.codigo || '').trim().toLowerCase()}_${String(item.lote || '').trim()}`)
                            );
                        } else {
                            avisoErro("Não foi possível carregar os itens detalhados do processo.");
                        }
                    })
                    .catch(() => {
                        avisoErro("Erro ao buscar os itens detalhados do processo.");
                    });
            },

            downloadModelo() {
                const link = document.createElement('a');
                link.href = '/downloads/Planilha_Estruturada_PROCESSOINTELIGENTE SOLLAI.xlsx';
                link.download = 'Planilha_Estruturada_PROCESSOINTELIGENTE SOLLAI.xlsx';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

            },

            async limparProcessoTotal() {
                const res = await axios.post(`${urlApi}/ProcessoItem/DeleteLotesPorProcesso`, {
                    idProcesso: this.idProcesso
                });

                if (res.data?.success === false) {
                    throw new Error(res.data?.msg || 'Falha ao limpar o processo.');
                }
            },

        },

        mounted() {

        },
        watch: {

        }
    }

</script>

<style scoped>
    .modal-grande {
        width: 100% !important;
        max-width: 1340px !important;
        margin: auto;
        margin-top: 18px;
        padding: 0 12px;
    }

    .modern-modal .modal-modern-content {
        border-radius: 20px;
        background: linear-gradient(135deg, #ffffff 5%, #f8fafc 100%);
        box-shadow: 0 20px 60px rgba(15, 23, 42, 0.18);
        position: relative;
    }

    .btn-close-modern {
        border-radius: 50%;
        border: 2px solid rgba(148, 163, 184, 0.28);
        background: #ffffff;
        transition: transform 0.2s ease, box-shadow 0.2s ease;
        z-index: 10;
    }

    .btn-close-modern:hover {
        transform: scale(1.06);
        box-shadow: 0 14px 34px rgba(37, 99, 235, 0.18);
    }

    .btn-md{
        z-index: 1001;
    }

    .modal-modern-header {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        gap: 18px;
        padding: 32px 32px 26px;
        position: relative;
    }

    .modal-modern-header::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 32px;
        right: 32px;
        height: 1px;
        background: linear-gradient(90deg, transparent, rgba(148, 163, 184, 0.35), transparent);
    }

    .header-icon {
        width: 60px;
        height: 60px;
        border-radius: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(135deg, rgba(59, 130, 246, 0.16) 0%, rgba(14, 165, 233, 0.16) 100%);
        color: #2563eb;
        flex-shrink: 0;
    }

    .header-text {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 6px;
    }

    .header-text h2 {
        margin: 0;
        font-size: 24px;
        font-weight: 700;
        color: #0f172a;
    }

    .header-text p {
        margin: 0;
        font-size: 14px;
        color: #475569;
        max-width: 420px;
        line-height: 1.5;
    }

    .header-steps {
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }

    .step-progress {
        display: inline-flex;
        align-items: center;
        gap: 12px;
        background: rgba(59, 130, 246, 0.08);
        border-radius: 16px;
        padding: 10px 16px;
        border: 1px solid rgba(59, 130, 246, 0.16);
    }

    .step-progress-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 4px;
        min-width: 62px;
        color: #64748b;
        transition: color 0.2s ease;
    }

    .step-progress-item span {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 28px;
        height: 28px;
        border-radius: 50%;
        border: 2px solid rgba(59, 130, 246, 0.3);
        font-weight: 700;
        font-size: 14px;
        background: #ffffff;
    }

    .step-progress-item small {
        font-size: 11px;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.3px;
    }

    .step-progress-item.active {
        color: #1d4ed8;
    }

    .step-progress-item.active span {
        border-color: #2563eb;
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
        color: #ffffff;
        box-shadow: 0 8px 18px rgba(37, 99, 235, 0.25);
    }

    .step-progress-item.completed span {
        border-color: #10b981;
        background: linear-gradient(135deg, #10b981 0%, #059669 100%);
        color: #ffffff;
        box-shadow: 0 8px 18px rgba(16, 185, 129, 0.25);
    }

    .step-progress-connector {
        width: 32px;
        height: 2px;
        background: linear-gradient(90deg, rgba(59, 130, 246, 0.2), rgba(59, 130, 246, 0.5));
        border-radius: 999px;
    }

    .step-progress-connector.completed {
        background: linear-gradient(90deg, rgba(16, 185, 129, 0.35), rgba(16, 185, 129, 0.8));
    }

    .modal-modern-body {
        padding: 32px;
        display: flex;
        flex-direction: column;
        gap: 28px;
    }

    :deep(#ModalRegrasTipo) {
        --bs-modal-margin: 2.5rem;
    }

    .modal-regras {
        width: 100% !important;
        max-width: 920px !important;
        margin: 2.5rem auto !important;
        padding: 0 16px;
        max-height: calc(100vh - 5rem);
    }

    .modal-regras .modal-modern-content {
        max-height: calc(100vh - 5rem);
        display: flex;
        flex-direction: column;
       
    }

    .modal-regras .modal-modern-header {
        flex-shrink: 0;
    }

    .modal-body-regras {
        padding: 28px 32px 32px;
        overflow-y: auto;
        flex: 1;
        min-height: 0;
    }

    .rules-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
        gap: 20px;
    }

    .rule-card {
        background: #ffffff;
        border-radius: 16px;
        border: 1px solid rgba(148, 163, 184, 0.2);
        box-shadow: 0 12px 26px rgba(15, 23, 42, 0.08);
        padding: 22px 24px;
        display: flex;
        flex-direction: column;
        gap: 14px;
    }

    .rule-header {
        display: flex;
        align-items: flex-start;
        gap: 14px;
    }

    .rule-header h4 {
        margin: 0;
        font-size: 18px;
        font-weight: 700;
        color: #0f172a;
    }

    .rule-header p {
        margin: 4px 0 0;
        font-size: 14px;
        color: #64748b;
        line-height: 1.45;
    }

    .rule-icon {
        width: 42px;
        height: 42px;
        border-radius: 14px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        color: #1f2937;
        font-size: 18px;
    }

    .rule-icon-blue {
        background: rgba(59, 130, 246, 0.12);
        color: #2563eb;
    }

    .rule-icon-teal {
        background: rgba(16, 185, 129, 0.12);
        color: #0f766e;
    }

    .rule-icon-purple {
        background: rgba(168, 85, 247, 0.14);
        color: #7c3aed;
    }

    .rule-icon-amber {
        background: rgba(251, 191, 36, 0.18);
        color: #b45309;
    }

    .rule-list {
        margin: 0;
        padding-left: 1.2rem;
        display: flex;
        flex-direction: column;
        gap: 8px;
        font-size: 14px;
        color: #475569;
    }

    .rule-list li {
        line-height: 1.45;
    }

    .rule-alert {
        color: #b91c1c;
        font-weight: 600;
    }

    .rule-list code {
        background: rgba(15, 23, 42, 0.08);
        padding: 2px 6px;
        border-radius: 6px;
        font-size: 13px;
        font-weight: 600;
        color: #111827;
    }

    .wizard-step {
        display: flex;
        flex-direction: column;
        gap: 24px;
    }

    .wizard-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
        gap: 24px;
    }

    .section-card {
        background: #ffffff;
        border-radius: 18px;
        border: 1px solid rgba(148, 163, 184, 0.18);
        box-shadow: 0 12px 28px rgba(15, 23, 42, 0.08);
        display: flex;
        flex-direction: column;
        gap: 18px;
        padding: 26px 28px;
    }

    .section-card-header {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .section-card-header h3 {
        margin: 0;
        font-size: 20px;
        font-weight: 700;
        color: #0f172a;
    }

    .section-card-header p {
        margin: 0;
        font-size: 14px;
        color: #64748b;
        line-height: 1.5;
        max-width: 460px;
    }

    .section-card-body {
        display: flex;
        flex-direction: column;
        gap: 18px;
    }

    .section-badge {
        align-self: flex-start;
        display: inline-flex;
        align-items: center;
        gap: 6px;
        padding: 6px 12px;
        border-radius: 12px;
        font-weight: 600;
        font-size: 12px;
        letter-spacing: 0.3px;
        text-transform: uppercase;
        background: rgba(37, 99, 235, 0.12);
        color: #1d4ed8;
        border: 1px solid rgba(37, 99, 235, 0.2);
    }

    .section-badge-secondary {
        background: rgba(16, 185, 129, 0.12);
        color: #047857;
        border-color: rgba(16, 185, 129, 0.24);
    }

    .mandatory-chips {
        display: flex;
        flex-direction: column;
        gap: 8px;
        padding: 16px;
        border-radius: 14px;
        background: rgba(37, 99, 235, 0.04);
        border: 1px dashed rgba(37, 99, 235, 0.2);
    }

    .mandatory-label {
        font-size: 13px;
        font-weight: 600;
        color: #1d4ed8;
        text-transform: uppercase;
        letter-spacing: 0.3px;
    }

    .mandatory-tags {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
    }

    .chip-obrigatorio {
        background: #2563eb;
        color: #ffffff;
        font-weight: 600;
        font-size: 12px;
        border-radius: 10px;
        padding: 4px 10px;
        letter-spacing: 0.2px;
    }

    .chip-opcional {
        background: rgba(100, 116, 139, 0.15);
        color: #475569;
        font-weight: 600;
        font-size: 12px;
        border-radius: 10px;
        padding: 4px 10px;
        letter-spacing: 0.2px;
        border: 1px dashed rgba(100, 116, 139, 0.35);
    }

    .mapping-hint-required {
        font-size: 13px;
        color: #b45309;
        background: rgba(245, 158, 11, 0.12);
        border: 1px solid rgba(245, 158, 11, 0.25);
        border-radius: 10px;
        padding: 10px 12px;
    }

    .info-blocks {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
        gap: 14px;
    }

    .info-block {
        display: flex;
        flex-direction: column;
        gap: 6px;
        padding: 16px 18px;
        border-radius: 14px;
        border: 1.5px solid rgba(148, 163, 184, 0.25);
        background: linear-gradient(135deg, #ffffff 0%, #f9fbff 100%);
        box-shadow: 0 6px 18px rgba(15, 23, 42, 0.06);
        text-align: left;
        color: #0f172a;
        transition: transform 0.2s ease, box-shadow 0.2s ease;
    }

    .info-block-title {
        font-size: 14px;
        font-weight: 700;
        color: #0f172a;
        margin: 0;
    }

    .info-block-desc {
        font-size: 13px;
        color: #6b7280;
        margin: 0;
        line-height: 1.45;
    }

    .info-block-clickable {
        cursor: pointer;
        border: 1.5px solid rgba(37, 99, 235, 0.24);
        background: linear-gradient(135deg, rgba(219, 234, 254, 0.6) 0%, rgba(191, 219, 254, 0.6) 100%);
        color: #1d4ed8;
    }

    .info-block-clickable:hover {
        transform: translateY(-2px);
        box-shadow: 0 12px 24px rgba(37, 99, 235, 0.18);
    }

    .info-block-clickable .info-block-title {
        color: #1d4ed8;
    }

    .info-block-clickable .info-block-desc {
        color: #1e3a8a;
    }

    .info-block-clickable:focus {
        outline: none;
        box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.2);
    }

    .info-block-clickable,
    .info-block-clickable .info-block-desc,
    .info-block-clickable .info-block-title {
        background-clip: padding-box;
    }

    .info-block-clickable {
        appearance: none;
        -webkit-appearance: none;
        text-align: left;
    }

    .upload-wrapper {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: stretch;
    }

    .upload-dropzone {
        border: 2px dashed rgba(37, 99, 235, 0.35);
        border-radius: 16px;
        padding: 38px 24px;
        text-align: center;
        background: rgba(59, 130, 246, 0.05);
        transition: background-color 0.2s ease, border-color 0.2s ease;
        position: relative;
    }

    .upload-dropzone:hover {
        background: rgba(59, 130, 246, 0.08);
        border-color: rgba(37, 99, 235, 0.55);
    }

    .upload-label {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 10px;
        cursor: pointer;
        width: 100%;
    }

    .upload-icon {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 60px;
        height: 60px;
        border-radius: 50%;
        background: rgba(37, 99, 235, 0.1);
        color: #2563eb;
    }

    .upload-text {
        font-size: 15px;
        font-weight: 600;
        color: #1d4ed8;
    }

    .upload-subtext {
        font-size: 13px;
        color: #64748b;
    }

    .file-thumbnail {
        display: flex;
        align-items: center;
        gap: 14px;
        padding: 18px 20px;
        border-radius: 16px;
        border: 1.5px solid rgba(37, 99, 235, 0.2);
        background: linear-gradient(135deg, rgba(219, 234, 254, 0.8) 0%, rgba(191, 219, 254, 0.8) 100%);
        color: #1e3a8a;
        box-shadow: 0 12px 24px rgba(37, 99, 235, 0.12);
    }

    .file-icon {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 48px;
        height: 48px;
        border-radius: 14px;
        background: rgba(37, 99, 235, 0.12);
        color: #1d4ed8;
    }

    .file-info {
        display: flex;
        flex-direction: column;
        gap: 4px;
        flex: 1;
    }

    .file-info strong {
        font-weight: 700;
        color: #0f172a;
        font-size: 15px;
    }

    .file-info span {
        font-size: 13px;
        color: #475569;
    }

    .file-remove-btn {
        border: none;
        background: rgba(239, 68, 68, 0.12);
        color: #b91c1c;
        border-radius: 999px;
        padding: 6px 10px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: background 0.2s ease, transform 0.2s ease;
    }

    .file-remove-btn:hover {
        background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
        color: #ffffff;
        transform: translateY(-1px);
    }

    .section-card.mapping-card {
        gap: 22px;
    }

    .gamify-mapping-container {
        max-height: 58vh;
        overflow-y: auto;
        overflow-x: hidden;
        padding-right: 4px;
    }

    .mapping-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
        gap: 18px;
        margin-bottom: 0;
    }

    .mapping-grid .mapping-card {
        min-height: 88px;
        background: linear-gradient(135deg, #f8fafc 75%, #dbeafe 100%);
        border: 2px solid rgba(148, 163, 184, 0.25);
        border-radius: 14px;
        box-shadow: 0 6px 18px rgba(15, 23, 42, 0.06);
        padding: 12px 14px 10px;
        transition: border 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
    }

    .mapping-grid .mapping-card.required {
        border-color: rgba(37, 99, 235, 0.35);
    }

    .mapping-grid .mapping-card.drop-hover {
        border-color: #2563eb;
        box-shadow: 0 12px 24px rgba(37, 99, 235, 0.18);
        transform: translateY(-1px);
    }

    .mapping-grid .mapping-card.missing {
        border-color: #f97316;
        box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.25);
    }

    .badge-estado {
        border-radius: 999px;
        padding: 2px 10px;
        font-size: 11px;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.3px;
    }

    .badge-required {
        background: rgba(239, 68, 68, 0.12);
        color: #b91c1c;
        border: 1px solid rgba(239, 68, 68, 0.25);
    }

    .badge-ok {
        background: rgba(34, 197, 94, 0.14);
        color: #15803d;
        border: 1px solid rgba(34, 197, 94, 0.3);
    }

    .badge-optional {
        background: rgba(148, 163, 184, 0.2);
        color: #475569;
        border: 1px solid rgba(148, 163, 184, 0.32);
    }

    .drop-area {
        min-height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 12px;
        margin-top: 8px;
        background: rgba(241, 245, 249, 0.8);
        transition: background 0.2s ease, border 0.2s ease;
        border: 1px dashed transparent;
        font-weight: 600;
        font-size: 14px;
        color: #475569;
        padding: 6px 10px;
    }

    .drop-area.has-chip {
        background: rgba(220, 252, 231, 0.85);
        border-color: rgba(34, 197, 94, 0.35);
    }

    .chip {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
        color: #ffffff;
        border-radius: 16px;
        padding: 6px 14px;
        font-size: 13px;
        font-weight: 600;
        box-shadow: 0 8px 18px rgba(37, 99, 235, 0.2);
        cursor: grab;
        transition: box-shadow 0.2s ease;
    }

    .chip-remove {
        cursor: pointer;
        opacity: 0.75;
        transition: opacity 0.2s ease;
    }

    .chip-remove:hover {
        opacity: 1;
    }

    .mapped-chip-ellipsis {
        max-width: 200px;
        display: inline-flex;
        align-items: center;
    }

    .chip-text-ellipsis {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 150px;
    }

    .available-header {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        padding: 10px 14px;
        border-radius: 12px;
        background: rgba(37, 99, 235, 0.1);
        color: #1d4ed8;
        font-weight: 600;
        margin-bottom: 12px;
    }

    .available-columns {
        display: flex;
        flex-direction: column;
        gap: 10px;
        width: 100%;
    }

    .drag-block {
        display: inline-flex;
        align-items: center;
        gap: 10px;
        padding: 10px 14px;
        border-radius: 12px;
        background: #f8fafc;
        border: 2px solid rgba(148, 163, 184, 0.25);
        font-weight: 600;
        font-size: 13px;
        cursor: grab;
        min-height: 40px;
        transition: transform 0.2s ease, box-shadow 0.2s ease, border 0.2s ease;
    }

    .drag-block:active {
        transform: scale(0.98);
        box-shadow: inset 0 0 0 2px rgba(59, 130, 246, 0.2);
    }

    .drag-icon {
        color: #94a3b8;
        font-size: 1rem;
    }

    .drag-block-text {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .step-warning {
        display: inline-flex;
        align-items: center;
        gap: 10px;
        padding: 12px 16px;
        border-radius: 12px;
        border: 1px solid rgba(239, 68, 68, 0.25);
        background: rgba(254, 226, 226, 0.6);
        color: #b91c1c;
        font-weight: 600;
        margin-top: 14px;
    }

    .modal-modern-footer {
        display: flex;
        justify-content: flex-end;
        gap: 12px;
        padding: 0 32px 32px;
        flex-wrap: wrap;
    }

    .modern-btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        padding: 12px 22px;
        border-radius: 14px;
        font-weight: 600;
        font-size: 14px;
        letter-spacing: 0.3px;
        text-transform: uppercase;
        border: none;
        cursor: pointer;
        transition: transform 0.2s ease, box-shadow 0.2s ease;
        box-shadow: 0 10px 24px rgba(15, 23, 42, 0.12);
        color: #ffffff;
    }

    .modern-btn:hover {
        transform: translateY(-2px);
    }

    .modern-btn:disabled {
        opacity: 0.6;
        cursor: not-allowed;
        transform: none;
        box-shadow: none;
    }

    .modern-btn-primary {
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
    }

    .modern-btn-secondary {
        background: linear-gradient(135deg, #cbd5e1 0%, #94a3b8 100%);
        color: #0f172a;
    }

    .modern-btn-light {
        background: linear-gradient(135deg, #e0f2fe 0%, #bfdbfe 100%);
        color: #1d4ed8;
        box-shadow: 0 8px 20px rgba(59, 130, 246, 0.18);
    }

    .fade-step-enter-active,
    .fade-step-leave-active {
        transition: opacity 0.25s ease, transform 0.25s ease;
    }

    .fade-step-enter-from,
    .fade-step-leave-to {
        opacity: 0;
        transform: translateY(6px);
    }

    @media (max-width: 992px) {
        .modal-modern-header {
            flex-direction: column;
            align-items: stretch;
            gap: 16px;
        }

        .header-steps {
            justify-content: flex-start;
        }
    }

    @media (max-width: 768px) {
        .modal-dialog.modal-grande {
            margin: 0;
            max-width: 100% !important;
        }

        .modal-modern-body {
            padding: 24px 20px;
        }

        .modal-modern-footer {
            padding: 0 20px 24px;
            justify-content: center;
        }

        .section-card {
            padding: 24px;
        }

        .wizard-grid {
            grid-template-columns: 1fr;
        }

        .info-blocks {
            grid-template-columns: 1fr;
        }

        .gamify-mapping-container {
            max-height: none;
        }

        .modal-body-regras {
            padding: 24px 20px 28px;
        }

        :deep(#ModalRegrasTipo) {
            --bs-modal-margin: 1.5rem;
        }

        .modal-dialog.modal-regras {
            margin: 1.5rem auto !important;
            padding: 0 12px;
            max-width: calc(100% - 24px) !important;
            max-height: calc(100vh - 3rem);
        }

        .modal-dialog.modal-regras .modal-modern-content {
            max-height: calc(100vh - 3rem);
        }

        .rules-grid {
            grid-template-columns: 1fr;
        }
    }

    @media (max-width: 576px) {
        .modal-modern-header,
        .modal-modern-body {
            padding: 22px 18px;
        }

        .modal-modern-footer {
            padding: 0 18px 22px;
        }

        .step-progress {
            width: 100%;
            justify-content: space-between;
        }

        .rule-card {
            padding: 20px 18px;
        }
    }

    :deep([data-bs-theme="dark"] .modern-modal .modal-modern-content) {
        background: linear-gradient(135deg, #0f172a 0%, #111827 100%);
        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.55);
    }

    :deep([data-bs-theme="dark"] .modern-modal .btn-close-modern) {
        background: rgba(15, 23, 42, 0.92) !important;
        border-color: rgba(148, 163, 184, 0.35) !important;
        color: #e2e8f0;
    }

    :deep([data-bs-theme="dark"] .modern-modal .modal-modern-header::after) {
        background: linear-gradient(90deg, transparent, rgba(148, 163, 184, 0.2), transparent);
    }

    :deep([data-bs-theme="dark"] .modern-modal .header-icon) {
        background: linear-gradient(135deg, rgba(59, 130, 246, 0.26) 0%, rgba(14, 165, 233, 0.26) 100%);
        color: #60a5fa;
    }

    :deep([data-bs-theme="dark"] .modern-modal .header-text h2) {
        color: #f8fafc;
    }

    :deep([data-bs-theme="dark"] .modern-modal .header-text p) {
        color: #94a3b8;
    }

    :deep([data-bs-theme="dark"] .modern-modal .step-progress) {
        background: rgba(59, 130, 246, 0.15);
        border-color: rgba(59, 130, 246, 0.25);
    }

    :deep([data-bs-theme="dark"] .modern-modal .section-card) {
        background: rgba(17, 24, 39, 0.9);
        border-color: rgba(148, 163, 184, 0.18);
        box-shadow: 0 16px 38px rgba(0, 0, 0, 0.4);
    }

    :deep([data-bs-theme="dark"] .modern-modal .section-card-header h3) {
        color: #f8fafc;
    }

    :deep([data-bs-theme="dark"] .modern-modal .section-card-header p) {
        color: #cbd5f5;
    }

    :deep([data-bs-theme="dark"] .modern-modal .rule-card) {
        background: rgba(17, 24, 39, 0.85);
        border-color: rgba(148, 163, 184, 0.18);
        box-shadow: 0 16px 32px rgba(0, 0, 0, 0.45);
    }

    :deep([data-bs-theme="dark"] .modern-modal .rule-header h4) {
        color: #f8fafc;
    }

    :deep([data-bs-theme="dark"] .modern-modal .rule-header p) {
        color: #94a3b8;
    }

    :deep([data-bs-theme="dark"] .modern-modal .rule-list) {
        color: #cbd5f5;
    }

    :deep([data-bs-theme="dark"] .modern-modal .rule-list code) {
        background: rgba(30, 41, 59, 0.75);
        color: #e2e8f0;
    }

    :deep([data-bs-theme="dark"] .modern-modal .rule-alert) {
        color: #fca5a5;
    }

    :deep([data-bs-theme="dark"] .modern-modal .mandatory-chips) {
        background: rgba(37, 99, 235, 0.18);
        border-color: rgba(37, 99, 235, 0.28);
    }

    :deep([data-bs-theme="dark"] .modern-modal .info-block) {
        background: rgba(30, 41, 59, 0.8);
        border-color: rgba(148, 163, 184, 0.18);
        color: #e2e8f0;
    }

    :deep([data-bs-theme="dark"] .modern-modal .info-block-desc) {
        color: #cbd5f5;
    }

    :deep([data-bs-theme="dark"] .modern-modal .info-block-clickable) {
        background: linear-gradient(135deg, rgba(37, 99, 235, 0.28) 0%, rgba(22, 78, 194, 0.28) 100%);
        border-color: rgba(37, 99, 235, 0.32);
        color: #bfdbfe;
    }

    :deep([data-bs-theme="dark"] .modern-modal .upload-dropzone) {
        background: rgba(30, 41, 59, 0.9);
        border-color: rgba(59, 130, 246, 0.35);
    }

    :deep([data-bs-theme="dark"] .modern-modal .upload-text) {
        color: #bfdbfe;
    }

    :deep([data-bs-theme="dark"] .modern-modal .upload-subtext) {
        color: #94a3b8;
    }

    :deep([data-bs-theme="dark"] .modern-modal .file-thumbnail) {
        background: linear-gradient(135deg, rgba(30, 41, 59, 0.9) 0%, rgba(17, 24, 39, 0.9) 100%);
        border-color: rgba(37, 99, 235, 0.32);
        color: #dbeafe;
    }

    :deep([data-bs-theme="dark"] .modern-modal .file-info strong) {
        color: #e2e8f0;
    }

    :deep([data-bs-theme="dark"] .modern-modal .file-info span) {
        color: #cbd5f5;
    }

    :deep([data-bs-theme="dark"] .modern-modal .mapping-grid .mapping-card) {
        background: linear-gradient(135deg, rgba(30, 64, 175, 0.22) 0%, rgba(15, 23, 42, 0.78) 100%);
        border-color: rgba(59, 130, 246, 0.28);
        color: #f8fafc;
    }

    :deep([data-bs-theme="dark"] .modern-modal .drop-area) {
        background: rgba(15, 23, 42, 0.75);
        color: #cbd5f5;
        border-color: rgba(59, 130, 246, 0.28);
    }

    :deep([data-bs-theme="dark"] .modern-modal .drop-area.has-chip) {
        background: rgba(22, 101, 52, 0.5);
        border-color: rgba(34, 197, 94, 0.4);
    }

    :deep([data-bs-theme="dark"] .modern-modal .drag-block) {
        background: rgba(15, 23, 42, 0.85);
        border-color: rgba(148, 163, 184, 0.25);
        color: #e2e8f0;
    }

    :deep([data-bs-theme="dark"] .modern-modal .available-header) {
        background: rgba(37, 99, 235, 0.25);
        color: #bfdbfe;
    }

    :deep([data-bs-theme="dark"] .modern-modal .step-warning) {
        background: rgba(190, 18, 60, 0.24);
        border-color: rgba(190, 18, 60, 0.32);
        color: #fecdd3;
    }

    :deep([data-bs-theme="dark"] .modern-modal .modern-btn-light) {
        background: linear-gradient(135deg, rgba(29, 78, 216, 0.65) 0%, rgba(30, 64, 175, 0.8) 100%);
        color: #e0f2fe;
    }

    :deep([data-bs-theme="dark"] .modern-modal .modern-btn-secondary) {
        background: linear-gradient(135deg, rgba(71, 85, 105, 0.9) 0%, rgba(51, 65, 85, 0.95) 100%);
        color: #f8fafc;
    }
</style>